/*
 * Tarjeta KPI del dashboard: valor del periodo, comparación con el periodo anterior (flecha + texto, verde
 * si mejora y salmón si empeora según `mejor_si` del servidor) y minigráfica con la serie diaria (spec 4.6).
 * `card` es un elemento de datos.kpis de /attendance/dashboard/; el formato sale de utils/dashboard.js.
 * Sin periodo anterior (anterior null) dice "Sin comparación" y no muestra "Antes"; nunca un 0 inventado.
 */
import React from "react";
import {CHART_COLORS, Sparkline} from "./charts";
import {formatKpiValue, kpiDelta, sparklineValues} from "../utils/dashboard";

const DIRECTION_ICONS = {sube: 'bx bx-up-arrow-alt', baja: 'bx bx-down-arrow-alt', igual: 'bx bx-minus'};
const TONE_COLORS = {up: CHART_COLORS.up, down: CHART_COLORS.down, neutral: CHART_COLORS.neutral, muted: CHART_COLORS.none};

/** Resumen textual de la minigráfica para lectores de pantalla (todos los valores de los días con dato). */
function sparkSummary(card, values) {
    if (values.length < 2) return `${card.titulo}: sin serie diaria suficiente`;
    const list = values.map((value) => formatKpiValue(card.unidad, value)).join(', ');
    return `${card.titulo} por día del periodo: ${list}`;
}

const KpiCard = ({card}) => {
    const delta = kpiDelta(card);
    const values = sparklineValues(card.serie || []);
    const hasPrevious = card.anterior !== null && card.anterior !== undefined;
    return (
        <article className={`mc-kpi mc-kpi--${delta.tone}`}>
            <h3 className="mc-kpi__title">{card.titulo}</h3>
            <p className="mc-kpi__value mc-num">{formatKpiValue(card.unidad, card.valor)}</p>
            <p className={`mc-badge mc-badge--${delta.tone} mc-kpi__delta`} title={delta.trend ? `${delta.trend}: ${delta.label}` : delta.label}>
                {delta.direction && <i className={DIRECTION_ICONS[delta.direction]} aria-hidden="true"/>}
                {delta.text}
                {delta.trend && <span className="mc-sr-only"> ({delta.trend})</span>}
            </p>
            {hasPrevious &&
                <p className="mc-kpi__vs">Antes: <span className="mc-num">{formatKpiValue(card.unidad, card.anterior)}</span></p>}
            <Sparkline values={values} color={TONE_COLORS[delta.tone]}
                       label={`${card.titulo} por día del periodo`} summary={sparkSummary(card, values)}/>
        </article>
    );
};

export default KpiCard;
